import type { MerchantSpec } from "@cpos/shared/src/dev-merchant/spec";
import type { CreateMerchantBloc } from "@/application/tools/create_merchant_bloc";
import { Checkbox } from "@/components/ui/base/checkbox";
import { SectionCard, FormField } from "./shared";
import { inputClass } from "./styles";

interface Props {
  draft: MerchantSpec;
  bloc: CreateMerchantBloc;
  disabled?: boolean;
}

export function StripeSection({ draft, bloc, disabled }: Props) {
  const { stripe } = draft;

  function patch(next: Partial<typeof stripe>) {
    bloc.setDraft({ stripe: { ...stripe, ...next } });
  }

  return (
    <SectionCard title="Stripe">
      <div className="space-y-3">
        <label className="text-foreground flex items-center gap-2 text-sm">
          <Checkbox
            checked={stripe.createConnectedAccount}
            onCheckedChange={(checked) =>
              patch({ createConnectedAccount: checked === true })
            }
            disabled={disabled}
          />
          Create Stripe connected account
        </label>

        {!stripe.createConnectedAccount && (
          <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
            No connected account will be created — the build pipeline skips the
            Stripe phase entirely for this merchant.
          </p>
        )}

        <label className="text-foreground flex items-center gap-2 text-sm">
          <Checkbox
            checked={stripe.subscription.skip}
            onCheckedChange={(checked) =>
              patch({
                subscription: {
                  ...stripe.subscription,
                  skip: checked === true,
                },
              })
            }
            disabled={disabled}
          />
          Skip subscription (admin-provisioned, bypasses Hub billing)
        </label>

        {!stripe.subscription.skip && (
          <FormField label="Trial days (optional)" className="max-w-xs">
            <input
              type="number"
              className={inputClass}
              value={stripe.subscription.trialDays ?? ""}
              onChange={(e) =>
                patch({
                  subscription: {
                    ...stripe.subscription,
                    trialDays: e.target.value
                      ? Number(e.target.value)
                      : undefined,
                  },
                })
              }
              disabled={disabled}
            />
          </FormField>
        )}

        <label className="text-foreground flex items-center gap-2 text-sm">
          <Checkbox
            checked={stripe.restricted}
            onCheckedChange={(checked) =>
              patch({ restricted: checked === true })
            }
            disabled={disabled || !stripe.createConnectedAccount}
          />
          Restricted (omit verification docs/external account so charges stay
          disabled)
        </label>
      </div>
    </SectionCard>
  );
}
